import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ApresentacaoResolverId } from '../../resolver/apresentacao.resolver';
import { ApresentacaoService } from '../../services/apresentacao.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Apresentacao } from '../../models/apresentacao.model';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { DomSanitizer } from '@angular/platform-browser';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-apresentacao-projetos',
  templateUrl: './apresentacao-projetos.component.html',
  styleUrls: ['./apresentacao-projetos.component.scss', './../../reuniao.scss']
})
export class ApresentacaoProjetosComponent extends BaseFormComponent<Apresentacao>  implements OnInit {

  id:number;
  filters: any;
  filterActive:boolean= false;
  agencies: object[] = [];
  iconData:any =  this.setFilePath('lupa_dados.svg');
  currentModalData:any = '';
  modalRef?: BsModalRef;

  @Input() print:boolean = false;
  
  @ViewChild('modal') modal: TemplateRef<any>;
  constructor(
      private router: Router,
      public activatedRoute: ActivatedRoute,
      public myService: ApresentacaoService,
      private apresentacaoResolverId: ApresentacaoResolverId,
      private sanitizer: DomSanitizer,
      private modalService: BsModalService,
    ) { 
      super(activatedRoute); 
    }

  ngOnInit() {
    this.loading();
    this.activatedRoute.parent.paramMap.subscribe(params => {
      this.id = +params.get('id');
    });
    this.start();
  }

  start(){
    this.apresentacaoResolverId.getById( this.id ).subscribe({
        next: (data) => {
          this.entity = data;
          var slide = 0;
          var filterAgencies = data.currentFilter?.agency_id ?? [];
          data?.agencyPf?.forEach(a => {
            var agencyMany = a?.tb_org_orgao_many;
            if(agencyMany && agencyMany.length >0){
              agencyMany.forEach(a2 =>{
                if(filterAgencies.includes(a2['num_codigo_pk'])){
                  this.agencies.push(a2);
                }
              })
            }
            else{
              if(filterAgencies.includes(a['num_codigo_pk'])){
                this.agencies.push(a);
              }
            }
          })
          console.log(this.agencies)
          this.filters = data.filters;
          this.loaded();
        },
        error: (error) => {
          this.loaded();
          this.msgError(error.error.message);
        }
      })
  }

  openAchievementAndGoal(item){
    this.currentModalData = {'agency':item};
    this.modalRef = this.modalService.show(this.modal,{class:"modal-g"});
  }

  closeModal() {
    this.modalRef?.hide();
  }

  setFilePath(filePath: string) {
    const fullPath = `assets/images/svgs/${filePath}`;
    return this.sanitizer.bypassSecurityTrustResourceUrl(fullPath);
  }
  
  generateLinkProject(item){
    return 'projetos/projeto/' + item.id + '/cadastro';
  }
  
  navigate(id:number){
    var currentUrl = this.router.routerState.snapshot.url;
    var newUrl = currentUrl.replace('projetos', 'indicador');
    this.router.navigate([newUrl], { queryParams: {slide: id + 1}});
  }
}
